import config from "@/config/config";
import { SignatureData } from "./imageSign.service";
import axios from "axios";

//

//

class ImageService {
  private http = axios.create({
    baseURL: `https://api.cloudinary.com/v1_1/${config.cloudinary.cloudName}`,
  });

  //

  /**
   * @param file The file to upload. Can be the actual data (byte array buffer), the Data URI (Base64 encoded), a remote FTP, HTTP or HTTPS URL of an existing file, or a private storage bucket (S3 or Google Storage) URL of a whitelisted bucket
   */
  public async upload(file: string, signatureData: SignatureData): Promise<string> {
    const { data } = await this.http.post<UploadImageResponse>("/auto/upload", {
      file,
      ...signatureData,
    });
    return data.url;
  }

  //

  /**
   * @param file The file to upload. Can be the actual data (byte array buffer), the Data URI (Base64 encoded), a remote FTP, HTTP or HTTPS URL of an existing file, or a private storage bucket (S3 or Google Storage) URL of a whitelisted bucket
   */
  public async uploadUnsigned(file: string): Promise<string> {
    const { data } = await this.http.post<UploadImageResponse>("/auto/upload", {
      file,
      upload_preset: "unsigned",
    });
    return data.url;
  }
}

//

export default new ImageService();

//

export interface UploadImageResponse {
  asset_id: string;
  public_id: string;
  version: number;
  version_id: string;
  signature: string;
  width: number;
  height: number;
  format: string;
  resource_type: string;
  created_at: string;
  tags: unknown[];
  pages: number;
  bytes: number;
  type: string;
  etag: string;
  placeholder: boolean;
  url: string;
  secure_url: string;
  asset_folder: string;
  display_name: string;
  original_filename: string;
  api_key: string;
}
